import React, { useState, useEffect } from "react";
import { Text } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/modals/ModalSelectStoreAndSection";
import { getProcessMonitorById } from "../../../../../../hooks/api/processMonitor";

export default function ViewProductsAfterToPost({ isLoad, data }) {
  const [processMonitorData, setProcessMonitorData] = useState(null);
  const [publicationStats, setPublicationStats] = useState({
    total: 0,
    successful: 0,
    failed: 0,
    errors: []
  });

  useEffect(() => {
    
    let intervalId;
    
    const fetchProcessMonitor = async () => {
      try {
        if (data?.processMonitorId) {
          const response = await getProcessMonitorById(data.processMonitorId);
          setProcessMonitorData(response?.data);
          
          // Procesar los datos del processMonitor
          processProcessMonitorData(response?.data);
          
          // Verificar si el proceso está completo
          const monitorData = response?.data;
          if (monitorData?.data?.status === "failed") {
            // Proceso falló, detener polling
            if (intervalId) {
              clearInterval(intervalId);
            }
            return false;
          } else if (monitorData?.data?.totalProducts && monitorData?.data?.currentProduct !== undefined) {
            // Si todos los productos están procesados, detener polling
            if (monitorData.data.currentProduct >= monitorData.data.totalProducts) {
              if (intervalId) {
                clearInterval(intervalId);
              }
              return false;
            }
          } else if (monitorData?.advance >= 100) {
            // Proceso completado sin datos de productos específicos
            if (intervalId) {
              clearInterval(intervalId);
            }
            return false;
          }
          
          return true; // continuar polling
        }
      } catch (error) {
        console.error('Error fetching process monitor:', error);
        return false;
      }
    };

    const startPolling = async () => {
      const shouldContinue = await fetchProcessMonitor();
      if (shouldContinue && !intervalId) {
        intervalId = setInterval(fetchProcessMonitor, 5000);
      }
    };

    if (data?.processMonitorId && (!processMonitorData || processMonitorData?.advance < 100)) {
      startPolling();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [data?.processMonitorId]);

  const processProcessMonitorData = (monitorData) => {
    
    let stats = {
      total: 0,
      successful: 0,
      failed: 0,
      errors: [],
      currentProduct: 0,
      totalProducts: 0,
      progress: 0
    };

    if (monitorData?.data?.status === "failed") {
      console.log("Proceso falló");
      stats.failed = 1;
      stats.total = 1;
      if (monitorData.data.errors && Array.isArray(monitorData.data.errors)) {
        stats.errors = monitorData.data.errors;
      } else if (monitorData.data.doing) {
        stats.errors.push(monitorData.data.doing);
      }
    } else {
      // Procesar datos de productos
      if (monitorData.data?.totalProducts && monitorData.data?.currentProduct !== undefined) {
        stats.totalProducts = monitorData.data.totalProducts;
        stats.currentProduct = monitorData.data.currentProduct;
        stats.total = stats.totalProducts;
        
        // Calcular progreso basado en productos procesados
        stats.progress = Math.round((stats.currentProduct / stats.totalProducts) * 100);
        
        // Si todos los productos están procesados
        if (stats.currentProduct >= stats.totalProducts) {
          stats.successful = stats.totalProducts;
          stats.failed = 0;
        } else {
          // Proceso en curso
          stats.successful = stats.currentProduct;
          stats.failed = 0;
          console.log("Proceso en curso");
        }
      } else if (monitorData?.advance >= 100) {
        stats.successful = 1;
        stats.total = 1;
        stats.progress = 100;
      }
    }

    console.log("Stats calculadas:", stats);
    setPublicationStats(stats);
  };

  const processCasheaResponse = (responseData) => {
    
    // Estructura esperada de respuesta de Cashea
    let stats = {
      total: 0,
      successful: 0,
      failed: 0,
      errors: []
    };

    if (responseData.error) {
      console.log("Procesando como ERROR");
      // Manejar error de publicación
      stats.errors.push(responseData.message || "Error en la publicación");
      stats.failed = 1;
      stats.total = 1;
    } else if (responseData.message) {
      console.log("Procesando como MENSAJE EXITOSO");
      // Respuesta exitosa con mensaje
      stats.successful = 1;
      stats.total = 1;
    } else if (responseData.success !== undefined) {
      console.log("Procesando como SUCCESS FIELD:", responseData.success);
      // Respuesta con campo success
      if (responseData.success) {
        stats.successful = 1;
        stats.total = 1;
      } else {
        stats.failed = 1;
        stats.total = 1;
        if (responseData.error) {
          stats.errors.push(responseData.error);
        }
      }
    } else if (responseData.data) {
      console.log("Procesando como DATA FIELD:", responseData.data);
      // Respuesta con estructura de datos
      if (Array.isArray(responseData.data)) {
        stats.total = responseData.data.length;
        stats.successful = responseData.data.filter(item => item.success !== false).length;
        stats.failed = responseData.data.filter(item => item.success === false).length;
        
        // Recopilar errores
        responseData.data.forEach((item, index) => {
          if (item.error) {
            stats.errors.push(`Producto ${index + 1}: ${item.error}`);
          }
        });
      } else {
        console.log("Data no es array, tratando como objeto único");
        // Datos no son array, tratar como un solo resultado
        stats.total = 1;
        if (responseData.data.success !== false) {
          stats.successful = 1;
        } else {
          stats.failed = 1;
          if (responseData.data.error) {
            stats.errors.push(responseData.data.error);
          }
        }
      }
    } else {
      console.log("Procesando como RESPUESTA DESCONOCIDA - asumiendo éxito");
      // Respuesta sin estructura conocida, asumir éxito
      stats.successful = 1;
      stats.total = 1;
    }

    console.log("Stats calculadas:", stats);
    setPublicationStats(stats);
  };

  const getStatusMessage = () => {
    // Si hay processMonitorData, verificamos el avance
    if (processMonitorData) {
      if (processMonitorData.data?.status === "failed") {
        return {
          message: "❌ Error en la publicación",
          color: "#721c24"
        };
      } else if (processMonitorData.data?.totalProducts && processMonitorData.data?.currentProduct !== undefined) {
        const current = processMonitorData.data.currentProduct;
        const total = processMonitorData.data.totalProducts;
        
        if (current >= total) {
          return {
            message: "✅ Proceso completado exitosamente",
            color: "#155724"
          };
        } else {
          return {
            message: `⏳ Procesando productos (${current}/${total})`,
            color: "#ffa500"
          };
        }
      } else if (processMonitorData.advance < 60) {
        return {
          message: "⏳ Estamos publicando tus productos a Cashea",
          color: "#ffa500"
        };
      } else if (processMonitorData.advance >= 60 && processMonitorData.advance < 100) {
        return {
          message: "🔄 Ya publicamos tus productos, estamos sincronizando",
          color: "#3498db"
        };
      } else if (processMonitorData.advance >= 100) {
        return {
          message: publicationStats.failed > 0 ? "❌ Error en la publicación" : "✅ Proceso completado exitosamente",
          color: publicationStats.failed > 0 ? "#721c24" : "#155724"
        };
      }
    }

    // Estado inicial o por defecto
    return {
      message: "⏳ Estamos publicando tus productos a Cashea",
      color: "#ffa500"
    };
  };

  const statusInfo = getStatusMessage();

  return (
    <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
      <div style={{ 
        borderRadius: "8px",
        padding: "0 30px",
        margin: "30px auto",
        maxWidth: 1200,
        textAlign: "left"
      }}>
        <Text size='18pt' fw='600' style={{ 
          color: statusInfo.color,
          marginBottom: "10px",
          display: "block",
          textAlign: "center"
        }}>
          {statusInfo.message}
        </Text>

        {processMonitorData?.advance >= 60 && processMonitorData?.advance < 100 && (
          <p style={{
            color: "#856404",
            backgroundColor: "#fff3cd",
            padding: "10px",
            borderRadius: "4px",
            margin: "0 auto 20px auto",
            maxWidth: "600px",
            textAlign: "center",
            fontSize: "14px"
          }}>
            ⚠️ Si tu producto no cumple todos los campos obligatorios será rechazado
          </p>
        )}

        {/* Mostrar progreso en tiempo real */}
        {isLoad && processMonitorData?.data?.totalProducts && processMonitorData?.data?.currentProduct !== undefined && (
          <div style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "15px",
            fontSize: "12px",
            maxWidth: 600,
            margin: "auto"
          }}>
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", marginBottom: "10px", color: "#2c3e50" }}>
                Progreso de la publicación en Cashea
              </h3>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ 
                backgroundColor: "#e3f2fd", 
                borderRadius: "4px", 
                padding: "15px", 
                textAlign: "center" 
              }}>
                <div style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>
                  {processMonitorData.data.currentProduct} / {processMonitorData.data.totalProducts} productos
                </div>
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  height: "20px", 
                  overflow: "hidden",
                  marginBottom: "10px"
                }}>
                  <div style={{
                    backgroundColor: "#4caf50",
                    height: "100%",
                    width: `${publicationStats.progress}%`,
                    transition: "width 0.3s ease"
                  }}></div>
                </div>
                <div style={{ fontSize: "14px", color: "#666" }}>
                  {publicationStats.progress}% completado
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "20px" }}>
              <div style={{ padding: "10px", backgroundColor: "#e3f2fd", borderRadius: "4px" }}>
                <strong>Total:</strong> {publicationStats.total}
              </div>
              <div style={{ padding: "10px", backgroundColor: "#e8f5e8", borderRadius: "4px" }}>
                <strong>Procesados:</strong> {publicationStats.successful}
              </div>
              <div style={{ padding: "10px", backgroundColor: "#ffeaa7", borderRadius: "4px" }}>
                <strong>Pendientes:</strong> {publicationStats.total - publicationStats.successful}
              </div>
            </div>

            {publicationStats.errors.length > 0 && (
              <div style={{ marginBottom: "20px" }}>
                <h4 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "10px", color: "#dc3545" }}>
                  Detalles de los errores:
                </h4>
                <div style={{
                  padding: "10px",
                  backgroundColor: "#f8d7da",
                  border: "1px solid #f5c6cb",
                  borderRadius: "4px"
                }}>
                  {publicationStats.errors.map((error, index) => (
                    <p key={index} style={{ margin: "0 0 5px 0", wordBreak: 'break-word' }}>
                      • {error}
                    </p>
                  ))}
                </div>
              </div>
            )}

            {/* {publicationStats.successful > 0 && publicationStats.failed === 0 && (
              <div style={{
                padding: "10px",
                backgroundColor: "#d4edda",
                border: "1px solid #c3e6cb",
                borderRadius: "4px",
                textAlign: "center"
              }}>
                <p style={{ margin: 0, color: "#155724", fontWeight: "600" }}>
                  🎉 Todos los productos se publicaron correctamente en Cashea
                </p>
              </div>
            )} */}
          </div>
        )}

        {/* Mostrar resultados finales cuando esté completado */}
        {/* {isLoad && processMonitorData?.data?.currentProduct >= processMonitorData?.data?.totalProducts && (
          <div style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "15px",
            fontSize: "12px",
            maxWidth: 600,
            margin: "auto"
          }}>
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", marginBottom: "10px", color: "#2c3e50" }}>
                ✅ Publicación completada en Cashea
              </h3>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "10px", marginBottom: "20px" }}>
              <div style={{ padding: "10px", backgroundColor: "#e8f5e8", borderRadius: "4px" }}>
                <strong>Productos publicados:</strong> {publicationStats.successful}
              </div>
              <div style={{ padding: "10px", backgroundColor: "#e3f2fd", borderRadius: "4px" }}>
                <strong>Estado:</strong> Completado
              </div>
            </div>

            <div style={{
              padding: "10px",
              backgroundColor: "#d4edda",
              border: "1px solid #c3e6cb",
              borderRadius: "4px",
              textAlign: "center"
            }}>
              <p style={{ margin: 0, color: "#155724", fontWeight: "600" }}>
                🎉 Todos los productos se publicaron correctamente en Cashea
              </p>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}
